<template>
    <div class="content-window-container"
         v-observe-visibility="visibilityChanged"
         :id="pageID">
        <div class="container">
            <div class="window-title will-animate" data-ani="animated fadeInDown">{{$t('Nav.Team')}}</div>

            <div class="team clear will-animate" data-ani="animated fadeInUp">
                <div class="team-member" v-for="(m, idx) in teamInfo" :key="idx">
                    <div class="avatar">
                        <img :src="m.Avatar"/>
                    </div>
                    <div class="text">
                        <div class="name" v-text="m.Name"></div>
                        <div class="title" v-text="m.Title"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {pageMounted, basicPageMethods} from "../js/common"
  import {scNamespace} from "../js/scNamespace"

  export default {
    name: "team",
    data() {
      return {
        pageID: scNamespace.PAGE.TEAM.id
      }
    },
    mounted: pageMounted,
    computed: {
      teamInfo() {
        return this.$t('Page.AboutUs.Team')
      }
    },
    methods: {
      ...basicPageMethods()
    }
  }
</script>

<style scoped>
    .team {
        padding: 20px 100px;
        margin-bottom: 10px;
        padding-top: 100px;
    }

    .team > div  {
        float: left;
        width: 20%;
    }

    .team > div img {
        width: 96px;
        height: auto;
        border-radius: 50%;
    }

    .window-content > div.out-links {
        margin-top: 20px;
    }

    .team > div.team-member > div {
        margin-bottom: 16px;
        text-align: center;
    }

    .team > div.team-member > div.avatar {
        margin-right: 10px;
    }
    .team > div.team-member div.text > div.name,
    .team > div.team-member div.text > div.title {
        font-size: 14px;
        padding-top: 8px;
    }
    .team > div.team-member div.text > div.name {
        font-size: 16px;
    }
    .team > div.team-member div.text > div.title {
        font-size: 14px;
        font-weight: 300;
    }

    @media screen and (max-width: 720px) {
        .container {
            padding-top: 60px;
        }

        .window-title {
            margin-bottom: 40px;
        }

        .team {
            padding: 0;
        }

        .team > div  {
            float: left;
            width: 50%;
        }

        .team > div img {
            width: 80px;
            border-radius: 50%;
        }

        .team > div.team-member {
            margin-bottom: 36px;
        }
        .team > div.team-member > div {
            margin-bottom: 0px;
            text-align: center;
        }

        .team > div.team-member > div.avatar {
            margin-right: 0px;
        }
        .team > div.team-member div.text > div.name,
        .team > div.team-member div.text > div.title {
            font-size: 14px;
            padding-top: 4px;
        }

        .team > div.team-member div.text > div.title {
            font-size: 12px;
            font-weight: 300;
            line-height: 12px;
        }
    }
</style>